import { render, staticRenderFns } from "./DeadHorse.vue?vue&type=template&id=c8b60e64&scoped=true&"
import script from "./DeadHorse.vue?vue&type=script&lang=js&"
export * from "./DeadHorse.vue?vue&type=script&lang=js&"
import style0 from "./DeadHorse.vue?vue&type=style&index=0&id=c8b60e64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b60e64",
  null
  
)

export default component.exports